import React, { useState } from 'react';
import { smsHistory, fileExport } from '../../../api-services';
import { createTable } from '@tanstack/react-table';
import TableManager from '../../../components/TableManager';
import { useDispatch } from 'react-redux';
import { openUserDetailsModal } from '../../../redux/features/modalSlice';
import { useMutation } from 'react-query';
import swal from 'sweetalert';
import moment from 'moment';

const callTypeOptions = [
  { label: 'Inbound', value: 'Inbound' },
  { label: 'Outbound', value: 'Outbound' },
];
const numberFilterTypes = [
  { label: 'Less Than', value: 'less_than' },
  { label: 'Greater Than', value: 'greater_than' },
  { label: 'Is Equal To', value: 'is_equal' },
  { label: 'Is Not Equal To', value: 'is_not_equal' },
  { label: 'Less or Equal to', value: 'less_or_equal' },
  { label: 'Greater or Equal to', value: 'greater_or_equal' },
];
const DateFilterTypes = [
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Last 7 Days', value: 'Last 7 Days' },
  { label: 'Last 30 Days', value: 'Last 30 Days' },
  { label: 'This Month', value: 'This Month' },
  { label: 'Last Month', value: 'Last Month' },
  { label: 'Custom', value: 'Custom' },
];

const initialValues = {
  filter: [
    {
      account_number: '',
      a_filter_type: '',
      placeholder: 'Enter MSISDN...',
      type: 'number',
      shouldFilterOptionDisabled: false,
      // filterOptions: numberFilterTypes,
      label: 'MSISDN',
    },
    {
      form: '',
      a_filter_type: '',
      placeholder: 'Enter Source...',
      type: 'text',
      shouldFilterOptionDisabled: false,
      label: 'Source',
    },
    {
      to: '',
      a_filter_type: '',
      placeholder: 'Enter Destination...',
      type: 'text',
      shouldFilterOptionDisabled: false,
      label: 'Destination',
    },
    {
      direction: '',
      a_filter_type: '',
      placeholder: 'Select Direction...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: callTypeOptions,
      label: 'Direction',
    },

    {
      date: {
        from: '',
        to: '',
      },
      a_filter_type: '',
      placeholder: 'Custom Date Range...',
      type: 'date',
      shouldFilterOptionDisabled: false,
      filterOptions: DateFilterTypes,
      selectOptions: [],
      label: 'Date',
    },
  ],
};

const table = createTable();

const SmsHistory = () => {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);

  const { isLoading: isLoadingExporting, mutateAsync: mutateAsyncExport } =
    useMutation('fileExport', (payload) => fileExport(payload, 'sms'), {
      onSuccess: (data) => {
        window.open(data?.data?.data);
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    });

  const handleOpenUserDetails = (shouldOpen, data) => {
    if (!shouldOpen) {
      return false;
    }

    dispatch(
      openUserDetailsModal({
        userModalOpen: true,
        userModalData: data,
      }),
    );
  };

  const handleFileExport = async (payload) => {
    await mutateAsyncExport(payload);
  };

  const columns = [
    table.createDataColumn('created_at', {
      id: 'created_at',
      header: 'Date',
      isSortable: true,
      cell: (props) => moment(props.getValue()).format('YYYY-MM-DD: HH:mm:ss'),
    }),
    table.createDataColumn((row) => row?.customer?.msisdn, {
      id: 'msisdn',
      header: 'MSISDN',
      shouldPointer: true,
      cell: (props) => (
        <span
          className="hover-name"
          onClick={() =>
            handleOpenUserDetails(
              props.getValue(),
              props?.row?.original?.customer,
            )
          }
        >
          {props.getValue()}
        </span>
      ),
    }),
    table.createDataColumn('from', {
      id: 'from',
      header: 'Source',
    }),
    table.createDataColumn('to', {
      id: 'to',
      header: 'Destination',
    }),
    // table.createDataColumn('text', {
    //   id: 'text',
    //   header: 'Message',
    //   textAlign: 'left',
    // }),
    table.createDataColumn('direction', {
      id: 'direction',
      header: 'Type',
      textAlign: 'left',
    }),

    table.createDataColumn('charge', {
      id: 'charge',
      header: 'Charge',
      isSortable: true,
    }),

    table.createDataColumn('charge_mode', {
      id: 'charge_mode',
      header: 'Charge Mode',
      isSortable: true,
    }),
    table.createDataColumn('name', {
      id: 'name',
      header: 'Provider',
      isSortable: true,
    }),
  ];

  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        filter={filters}
        fetcherKey="smsHistory"
        fetcherFn={smsHistory}
        title="SMS Report"
        shouldFilter={true}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        initialValues={initialValues}
        setFilters={setFilters}
        filters={filters}
        shouldExport={true}
        exportCtaFn={handleFileExport}
        isExporting={isLoadingExporting}
      />
    </>
  );
};

export default SmsHistory;
